export class Species {
    id: number | null = null;
    name: string = '';
    hasVaccines: boolean = false;
}